import { render } from "./attribute_xx_add.vue?vue&type=template&id=e8479a6c&scoped=true"
import script from "./attribute_xx_add.vue?vue&type=script&lang=js"
export * from "./attribute_xx_add.vue?vue&type=script&lang=js"

import "./attribute_xx_add.vue?vue&type=style&index=0&id=e8479a6c&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8479a6c"]])

export default __exports__